import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CrmOverviewComponent } from './crm-overview/crm-overview.component';

export const routes: Routes = [
    { path: '', redirectTo: 'crm', pathMatch: 'full' },
    { path: 'crm', component: CrmOverviewComponent },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
